module.exports = __webpack_public_path__ + "img/mscontin.d6f47e0b.png";